import { observer } from 'mobx-react';
import React from 'react';

import type Asset from 'stores/Asset';

import DrawerButton from '../DrawerButton';

export interface NavigateToFolderButtonProps {
  asset: Asset;
}

function NavigateToFolderButton({ asset }: NavigateToFolderButtonProps) {
  const navigateToFolder = () => {
    asset.parent?.setCurrentFolder(asset.data.path);
  };

  return (
    <DrawerButton disabled={asset.loading} onClick={navigateToFolder}>
      Open
    </DrawerButton>
  );
}

export default observer(NavigateToFolderButton);
